import * as Factory from 'factory.ts'
import faker from 'faker'

import { type Currency } from '../../models'

export const CurrencyMock = Factory.Sync.makeFactory<Currency>({
  id: Factory.each(() => faker.random.number()),
  active: true,
  base: false,
  description: faker.lorem.sentence(),
  name: 'CAD',
  rate: faker.finance.amount(1, 100, 8),
})
